import { customGaEvent, GA_EVENTS } from '../utils/ga';

export const switchMapView = ({ miniMapView: view, id, name }) => {
  id &&
    name &&
    customGaEvent({
      action: GA_EVENTS.SWITCH_TOUR_VIEW,
      label: view,
    });
  return { type: 'SWITCH_MAP_VIEW', show: view };
};
